import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/procedure//icon_arrow-left_black.svg'
import _imports_1 from '../assets/images/joyworks_logo3.png'


const _withScopeId = n => (_pushScopeId("data-v-400f488c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"height":"100%"} }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "img" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "opacity_wrapper" }, null, -1))
const _hoisted_4 = { class: "form_container" }
const _hoisted_5 = { class: "section1" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "뒤로", -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { class: "text_box" }
const _hoisted_10 = { class: "user_text" }
const _hoisted_11 = { class: "text_highlight" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "detail_title_text" }, "A/S 현재 진행 상태", -1))
const _hoisted_13 = { class: "section2" }
const _hoisted_14 = { class: "step_wrap" }
const _hoisted_15 = {
  key: 0,
  class: "section3"
}
const _hoisted_16 = { class: "info_wrap" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info_text company" }, "매장명", -1))
const _hoisted_18 = { class: "info_text company_name" }
const _hoisted_19 = {
  key: 1,
  class: "section3"
}
const _hoisted_20 = { class: "info_wrap" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info_text company" }, "택배회사", -1))
const _hoisted_22 = { class: "info_text company_name" }
const _hoisted_23 = { class: "info_wrap" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info_text company" }, "송장번호", -1))
const _hoisted_25 = { class: "info_text company_name" }
const _hoisted_26 = { class: "section3" }
const _hoisted_27 = { class: "button_text" }

import router from "@/router";
import { onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import repairAPI from "@/api/repairAPI";
import authAPI from "@/api/authAPI";

export default /*#__PURE__*/_defineComponent({
  __name: 'ClientDetail',
  setup(__props) {

const store = useStore();
const route = useRoute();
const userInfo = ref();
const textValue = ref("");
const detailData: any = ref({
  COLOR_NAME: null,
  CUS_HP_NO: "",
  CUS_NAME: "",
  DATES: "",
  EMP_NAME: null,
  E_STATUS: "",
  IMG_LIST: [],
  ITM_NAME: "",
  SEQ_NO: "",
  SIZE_NAME: null,
  STATUS: "",
  STR_NAME: "",
  CHUL_NO: "",
  COURIER_CODE: "",
  COURIER_NAME: "",
});
const checkSession = () => {
  authAPI
    .checkSession()
    .then((res: any) => {
      console.log(res);
      const data = res.data.data;
      if (data.result == "FAIL") {
        router.push({ name: "clientLogin" });
      }
    })
    .catch((error: any) => {
      console.log(error);
      alert(error);
    });
};
onMounted(() => {
  checkSession();
  userInfo.value = store.getters.getUserInfo;
  repairAPI.GetRepairDetail({ SEQ_NO: route.params.SEQ_NO, CUS_HP_NO: userInfo.value.EMP_NO }).then((res: any) => {
    console.log("123", res.data.data);
    detailData.value = res.data.data;
    if (detailData.value.COURIER_CODE == "01") {
      detailData.value.COURIER_NAME = "대한통운";
    } else if (detailData.value.COURIER_CODE == "02") {
      detailData.value.COURIER_NAME = "로젠";
    } else {
      detailData.value.COURIER_NAME = "";
    }
    textValue.value = detailData.value.CS_STATUS == null ? "접수내용 (수정)" : "접수내용 (확인)";
    console.log(detailData.value.STATUS);
    if (detailData.value.STATUS == "01" && detailData.value.CS_STATUS == null) {
      detailData.value.STATUS = 1;
    } else if (detailData.value.STATUS == "01" && detailData.value.CS_STATUS != null) {
      detailData.value.STATUS = 2;
    } else if (detailData.value.STATUS == "02" || detailData.value.STATUS == "03" || detailData.value.STATUS == "04") {
      detailData.value.STATUS = 3;
    } else {
      detailData.value.STATUS = 4;
    }

    // detailData.value.STATUS = Number(detailData.value.STATUS);
  });
});
const registPage = () => {
  router.push({ name: "clientUpdate", params: { SEQ_NO: detailData.value.SEQ_NO } });
};
const goHome = () => {
  router.push({ name: "clientHome" });
};
const goBack = () => {
  router.go(-1);
};
const goPage = () => {
  const chul_no: any = detailData.value.CHUL_NO;
  const url: string = `https://trace.cjlogistics.com/web/detail.jsp?slipno=${chul_no}`;
  window.open(url, "_blank");
};

return (_ctx: any,_cache: any) => {
  const _component_el_step = _resolveComponent("el-step")!
  const _component_el_steps = _resolveComponent("el-steps")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", { class: "section_header_wrap" }, [
          _createElementVNode("div", {
            onClick: goBack,
            class: "back_btn_box"
          }, _hoisted_8),
          _createElementVNode("img", {
            class: "img_logo",
            src: _imports_1,
            style: {"cursor":"pointer"},
            onClick: goHome,
            alt: ""
          })
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("span", _hoisted_11, _toDisplayString(userInfo.value?.EMP_NO), 1),
            _createTextVNode(" 님 ")
          ]),
          _hoisted_12
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_el_steps, {
            active: detailData.value.STATUS,
            "finish-status": "success",
            "align-center": ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_step, { title: "접수등록" }),
              _createVNode(_component_el_step, { title: "접수확인" }),
              _createVNode(_component_el_step, { title: "수선진행중" }),
              _createVNode(_component_el_step, { title: "택배배송" })
            ]),
            _: 1
          }, 8, ["active"])
        ])
      ]),
      (detailData.value.COURIER_TYPE == '02')
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createElementVNode("div", _hoisted_18, _toDisplayString(detailData.value.STR_NAME), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      (detailData.value.COURIER_TYPE == '01')
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _hoisted_21,
              _createElementVNode("div", _hoisted_22, _toDisplayString(detailData.value.COURIER_NAME), 1)
            ]),
            _createElementVNode("div", _hoisted_23, [
              _hoisted_24,
              _createElementVNode("div", _hoisted_25, _toDisplayString(detailData.value.CHUL_NO), 1)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", {
                onClick: goPage,
                class: "chul_btn"
              }, "택배사 조회")
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("div", {
          onClick: registPage,
          class: "button_box"
        }, [
          _createElementVNode("div", _hoisted_27, _toDisplayString(textValue.value), 1)
        ])
      ])
    ])
  ]))
}
}

})